import React, { useEffect, useState, memo, useRef } from "react";
import Button from "@atlaskit/button/standard-button";
import DynamicTable from "@atlaskit/dynamic-table";
import RefreshIcon from "@atlaskit/icon/glyph/refresh";
import Pagination from "@atlaskit/pagination";
import { CheckboxSelect, RadioSelect } from "@atlaskit/select";
import Spinner from "@atlaskit/spinner";
import FilterIcon from "@atlaskit/icon/glyph/filter";
import DownloadIcon from "@atlaskit/icon/glyph/download";
import SearchIcon from "@atlaskit/icon/glyph/search";
import CrossCircleIcon from "@atlaskit/icon/glyph/cross-circle";
import Textfield from "@atlaskit/textfield";
import Form, { Field, ErrorMessage } from "@atlaskit/form";
import Badge from "@atlaskit/badge";
import ModalPrompt from "../../components/Shared/Modal/ModalPrompt";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from "@atlaskit/modal-dialog";
import {
  TableWrapper,
  createCells,
  createHead,
} from "../../components/Jobs/Table/WrapperBackup";
import { API } from "../../utility/Api";
import { errorHandler } from "../../helpers/helpers";
import styles from "./Jobs.module.css";
import moment from "moment";
import { statusList, timeframeJobs } from "../../constants/constants";
import { UseToast } from "../../components/context/ToastContext";
import { useNavigate } from "react-router-dom";
const Jobs = (props) => {
  const navigate = useNavigate();
  const [pageData, setPageData] = useState({
    pagination: { page: "1", size: "50" },
  });
  const [totalPages, setTotalPages] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  // const [isError, setError] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [jobDetails, setJobDetails] = useState({});
  const [moreJobDetails, setMoreJobDetails] = useState([]);
  const [refreshPage, setRefreshPage] = useState(false);
  const [downloadDisable, setDownloadDisable] = useState(true);
  const [statusValues, setStatusValues] = useState("");
  const [timeframeValue, setTimeframeValue] = useState(2);
  const { setMainMessage } = UseToast();
  const [sortFlags, setSortFlags] = useState({
    startTimeSortFlag: 0,
    endTimeSortFlag: 0,
    timeTakenSortFlag: 0,
    statusSortFlag: 0,
    tagSortFlag: 0,
  });
  const [searchText, setSearchText] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [filterData, setFilterData] = useState({
    filter: {
      jobType: props.appType,
      timeframe: 2,
      status: [],
      sortFlag: false,
      sortOrder: "",
      sortingField: "",
    },
  });

  const [totalIssueCount, setTotalIssueCount] = useState(0);
  const [totalScreenCount, settotalScreenCount] = useState(0);
  const [totalWorkflowCount, settotalWorkflowCount] = useState(0);
  const validate = useRef("");
  useEffect(() => {
    // Get issues, screens , workflows, for current tenant
    const getScreenCount = async (token) => {
      // eslint-disable-next-line no-undef
      await AP.request("/rest/api/3/screens?maxResults=0", {
        success: function (responseText) {
          const data = JSON.parse(responseText);
          settotalScreenCount(data.total);
        },
      });
    };
    const getWorkflowCount = async (token) => {
      // eslint-disable-next-line no-undef
      await AP.request("/rest/api/3/workflow/search?maxResults=0", {
        success: function (responseText) {
          const data = JSON.parse(responseText);
          settotalWorkflowCount(data.total);
        },
      });
    };
    const getIssueCount = async (token) => {
      // eslint-disable-next-line no-undef
      await AP.request("/rest/api/3/search?maxResults=0", {
        success: function (responseText) {
          const data = JSON.parse(responseText);
          setTotalIssueCount(data.total);
        },
      });
    };
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      getScreenCount(token);
      getWorkflowCount(token);
      getIssueCount(token);
    });
  }, []);
  const getMoreJobDetails = (jobDetails) => {
    const getdetails = async (token) => {
      setLoading(true);
      await API.get(
        `api/job_details?jobId=${jobDetails.jobId}&jobType=${jobDetails.type}`,
        {
          headers: {
            Authorization: `JWT ${token}`,
          },
        }
      )
        .then(function (response) {
          setLoading((prev) => !prev);
          jobDetails.type === "Issues"
            ? setMoreJobDetails(response.data.projectsMetadata)
            : setMoreJobDetails({});
        })
        .catch(function (error) {
          const data = errorHandler(error);
          // setError(data.message);
          setMainMessage({ appearance: "error", text: data.message });
          setLoading(false);
        });
    };

    // eslint-disable-next-line no-undef
    AP.context.getToken(function (token) {
      getdetails(token);
    });
  };
  const handleModal = (jobDetails) => {
    setJobDetails(jobDetails);
    setModalIsOpen(true);
    getMoreJobDetails(jobDetails);
  };
  const brandColor = "#253858";
  const textColor = "#F4F5F7";

  const CustomStyle = (val) => {
    return {
      control: (base) => ({
        ...base,
        backgroundColor:
          val && val.length !== 0 ? brandColor : base.backgroundColor,

        ":active": {
          backgroundColor:
            val && val.length !== 0 ? brandColor : base.backgroundColor,
        },
        ":hover": {
          backgroundColor:
            val && val.length !== 0 ? brandColor : base.backgroundColor,
        },
      }),
      singleValue: (base) => ({
        ...base,
        color: val ? textColor : base.backgroundColor,
      }),
      multiValue: (base) => ({
        ...base,
        color: val ? textColor : base.backgroundColor,
      }),
      dropdownIndicator: (base) => ({
        ...base,
        color: val ? textColor : base.backgroundColor,
      }),
      valueContainer: (base) => ({
        ...base,
        color: val && val !== "" ? textColor : base.backgroundColor,
      }),
      input: (base) => ({
        ...base,
        width: "max-content",
      }),
      menu: (base) => ({
        ...base,
        width: "max-content",
        minWidth: "150px",
      }),
    };
  };

  const SingleValue = (props) => (
    // <components.SingleValue {...props}>
    <strong>Start time : {props.data.label}</strong>
    // </components.SingleValue>
  );

  const MultiValue = ({ getValue, index }) => {
    const otherCount = getValue().length - 1;
    const BadgeNumber =
      otherCount > 0 ? <Badge appearance="primary"> +{otherCount} </Badge> : "";
    const display = `${getValue()[getValue().length - 1].label}`;
    return (
      !index && (
        <strong>
          Status :&nbsp;{display}
          &nbsp; {BadgeNumber}
        </strong>
      )
    );
  };

  useEffect(() => {
    const queryparams = `page=${pageData.pagination.page}&size=${
      pageData.pagination.size
    }${searchText ? `&searchText=${searchText}` : ""}`;
    const getBackupJobs = async (token) => {
      setLoading(true);
      // setError("");
      let url = "";
      if (props.appType === "Backup") url = "api/backup_jobs";
      else if (props.appType === "Restore") url = "api/restore_jobs";

      await API.post(`${url}?${queryparams}`, filterData, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          response.data.totalCount === 0
            ? setDownloadDisable(true)
            : setDownloadDisable(false);
          setTableData(response.data.backupJobs);
          sendAllAccountId(response.data.uniqueUsers, response.data.backupJobs);
          setTotalPages(response.data.totalCount);
          setLoading(false);
        })
        .catch(function (error) {
          const data = errorHandler(error);
          // setError(data.message);
          setMainMessage({ appearance: "error", text: data.message });
          setLoading(false);
        });
    };

    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      getBackupJobs(token);
    });
  }, [props.selected, pageData, refreshPage, props.appType, filterData]);

  const handleSorting = (field, sortingOrder) => {
    setSortFlags((prevState) => ({
      startTimeSortFlag:
        field === "start_time"
          ? prevState.startTimeSortFlag === 0
            ? 1
            : prevState.startTimeSortFlag === 1
            ? 2
            : prevState.startTimeSortFlag === 2
            ? 0
            : 0
          : 0,
      endTimeSortFlag:
        field === "end_time"
          ? prevState.endTimeSortFlag === 0
            ? 1
            : prevState.endTimeSortFlag === 1
            ? 2
            : prevState.endTimeSortFlag === 2
            ? 0
            : 0
          : 0,
      timeTakenSortFlag:
        field === "time_taken"
          ? prevState.timeTakenSortFlag === 0
            ? 1
            : prevState.timeTakenSortFlag === 1
            ? 2
            : prevState.timeTakenSortFlag === 2
            ? 0
            : 0
          : 0,
      statusSortFlag:
        field === "status"
          ? prevState.statusSortFlag === 0
            ? 1
            : prevState.statusSortFlag === 1
            ? 2
            : prevState.statusSortFlag === 2
            ? 0
            : 0
          : 0,
      tagSortFlag:
        field === "tag"
          ? prevState.tagSortFlag === 0
            ? 1
            : prevState.tagSortFlag === 1
            ? 2
            : prevState.tagSortFlag === 2
            ? 0
            : 0
          : 0,
    }));
    setFilterData((prevState) => ({
      filter: {
        jobType: props.appType,
        timeframe: prevState.filter.timeframe,
        status: prevState.filter.status,
        sortFlag: sortingOrder !== "" ? true : false,
        sortOrder: sortingOrder,
        sortingField: sortingOrder !== "" ? field : "",
      },
    }));
  };
  const head = createHead(false, props.appType, sortFlags, handleSorting);

  const rows = createCells(
    tableData,
    props.appType,
    totalIssueCount,
    navigate,
    totalPages
  );

  const onPaginationChange = (e, page) => {
    setPageData((prevState) => ({
      ...prevState,
      pagination: {
        page: page,
        size: prevState.pagination.size,
      },
    }));
  };
  const handleSetPage = (e) => {
    setPageData((prevState) => ({
      ...prevState,
      pagination: { page: e ? e : "1", size: prevState.pagination.size },
    }));
  };
  const handleRefreshPage = (e) => {
    setRefreshPage((prevState) => !prevState);
    setPageData({ pagination: { page: "1", size: "50" } });
  };
  const handleDownloadData = () => {
    let url;
    setLoading(true);
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      downloadFile(token);
    });
    const downloadFile = async (token) => {
      // setError("");
      const data = {
        fileFormat: "csv",
        // operation: "download:job_list",
      };
      if (props.appType === "Backup") url = "api/backup_download_job_list";
      else if (props.appType === "Restore")
        url = "api/restore_download_job_list";

      await API.post(url, data, {
        responseType: "arraybuffer",
        headers: {
          Authorization: `JWT ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then(function (response) {
          const fileName =
            `Revyz_Jobs_` +
            moment().utc().format("MM-DD-YYYY") +
            "-" +
            moment().utc().get("hour") +
            "-" +
            moment().utc().get("minute") +
            "-" +
            moment().utc().get("second");
          const jsonString = window.URL.createObjectURL(
            new Blob([response.data])
          );
          const link = document.createElement("a");
          link.href = jsonString;
          link.download = fileName + ".csv";
          link.click();
          link.remove();
          setLoading(false);
        })
        .catch(function (error) {
          const data = errorHandler(error);
          // setError(data.message);
          setMainMessage({ appearance: "error", text: data.message });
          setLoading(false);
        });
    };
  };

  const handleTimeframeChange = (e) => {
    const timeframeValue = e.value;
    setTimeframeValue(timeframeValue);
  };
  const handleStatusChange = (e) => {
    const statusValues = e.map((val) => val.value);
    setStatusValues(statusValues);
  };

  const handleFilters = () => {
    if (searchText) setSearchText("");
    setFilterData((prevState) => ({
      filter: {
        jobType: props.appType,
        timeframe: timeframeValue ? timeframeValue : 2,
        status: statusValues ? statusValues : [],
        sortFlag: prevState.filter.sortFlag,
        sortOrder: prevState.filter.sortOrder,
        sortingField: prevState.filter.sortingField,
      },
    }));
    setPageData({
      pagination: { page: "1", size: "50" },
    });
  };

  const clearSearch = () => {
    setSearchText("");
    setRefreshPage((prev) => !prev);
    validate.current = "";
  };

  // if (Number(type) === 1) {
  //   setMessage({
  //     text: message,
  //     appearance: "success",
  //   });
  // } else if (Number(type) === 2) {
  //   setMessage({
  //     text: "Backup job triggered successfully",
  //     appearance: "info",
  //   });
  // }

  let userNameList = [];
  let accountIdList = [];
  let avatarUrlList = [];

  const sendAllAccountId = (uniqueAccId, data) => {
    //Initialise data
    const initialdata = data.map((record) => {
      return { ...record, userName: "-", avatar: "" };
    });
    setTableData(initialdata);
    setLoading(false);
    var promise = new Promise(function (resolve, reject) {
      uniqueAccId.forEach((accountId, index) => {
        var promise2 = new Promise(function (resolve, reject) {
          //eslint-disable-next-line
          AP.request(`/rest/api/3/user?accountId=${accountId}`)
            .then((response) => {
              const responsedata = JSON.parse(response.body);
              resolve({
                displayName: responsedata.displayName,
                accountId: accountId,
                avatarUrl: Object.values(responsedata.avatarUrls)[1],
              });
            })
            .catch((e) =>
              reject({
                displayName: "Not found",
                accountId: accountId,
                avatarUrl: "",
              })
            );
        });
        promise2
          .then(({ displayName, accountId, avatarUrl }) => {
            userNameList.push(displayName);
            accountIdList.push(accountId);
            avatarUrlList.push(avatarUrl);
            if (userNameList.length === uniqueAccId.length)
              resolve({
                nameList: userNameList,
                idList: accountIdList,
                avatarList: avatarUrlList,
              });
          })
          .catch(({ displayName, accountId, avatarUrl }) => {
            userNameList.push(displayName);
            accountIdList.push(accountId);
            avatarUrlList.push(avatarUrl);
            if (userNameList.length === uniqueAccId.length)
              reject({
                nameList: userNameList,
                idList: accountIdList,
                avatarList: avatarUrlList,
              });
          });
      });
    });
    promise
      .then(({ nameList, idList, avatarList }) => {
        updateUserDetails(data, nameList, idList, avatarList);
      })
      .catch(({ nameList, idList, avatarList }) => {
        updateUserDetails(data, nameList, idList, avatarList);
      });
  };

  const updateUserDetails = (data, nameList, idList, avatarList) => {
    const newData = data.map((ele) => {
      let index = idList.indexOf(ele.initiatorAccountId);
      return { ...ele, userName: nameList[index], avatar: avatarList[index] };
    });
    setTableData(newData);
    setLoading(false);
  };

  return (
    <div className={styles.container}>
      <ModalTransition>
        {showConfirmation && (
          <Modal onClose={() => setShowConfirmation(false)}>
            <ModalHeader>
              <ModalTitle>
                Download report
                {isLoading && <Spinner size="small" />}
              </ModalTitle>
            </ModalHeader>
            <ModalBody>
              Downloading report will download a csv file containing{" "}
              {props.appType === "Backup" ? "backup" : "restore"} jobs
              information.
            </ModalBody>
            <ModalFooter>
              <Button
                appearance="subtle"
                onClick={() => setShowConfirmation(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                onClick={() => {
                  handleDownloadData();
                  setShowConfirmation(false);
                }}
                appearance="primary"
                autoFocus
              >
                Download
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>

      {/* {isError ? (
        <div className={styles.error}>
          <FlagError setFlag={[1]} message={isError} />
        </div>
      ) : (
        ""
      )} */}
      <div className={styles.filtersandrefreshcontainer}>
        <div className={styles.selectContainer}>
          <div className={styles.searchbarcontainer}>
            <Form
              onSubmit={(data) => {
                setSearchText(data.searchText);
                setStatusValues("");
                setFilterData({
                  filter: {
                    jobType: props.appType,
                    timeframe: 2,
                    status: [],
                    sortFlag: false,
                    sortOrder: "",
                    sortingField: "",
                  },
                });
                setSortFlags({
                  startTimeSortFlag: 0,
                  endTimeSortFlag: 0,
                  timeTakenSortFlag: 0,
                  statusSortFlag: 0,
                });
              }}
              isDisabled={isLoading}
            >
              {({ formProps }) => (
                <form {...formProps}>
                  <div className={styles.filterItem}>
                    <Field
                      name="searchText"
                      defaultValue={searchText}
                      // validate={async (value) => {
                      //   const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");
                      //   if (regexp.test(value)) {
                      //     return undefined;
                      //   } else {
                      //     return "Please Enter Valid Search Text";
                      //   }
                      // }}
                    >
                      {({ fieldProps, error }) => (
                        <>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "row",
                              gap: "2px",
                              marginTop: "-8px",
                            }}
                          >
                            <Textfield
                              elemAfterInput={
                                <div
                                  style={{
                                    paddingRight: "6px",
                                    lineHeight: "100%",
                                  }}
                                >
                                  <SearchIcon
                                    size="small"
                                    borderColor="transparent"
                                  />
                                </div>
                              }
                              placeholder="Search by Job Id"
                              {...fieldProps}
                              onChange={(value) => {
                                setSearchText(value.target.value);
                                fieldProps.onChange(value);
                                const regexp = new RegExp(
                                  "^[ A-Za-z0-9@#_-]*$"
                                );

                                if (regexp.test(value.target.value)) {
                                  validate.current = "";
                                } else {
                                  validate.current = "error";
                                }
                              }}
                            />
                            {searchText.length !== 0 && (
                              <Button
                                size="small"
                                appearance="subtle"
                                onClick={clearSearch}
                              >
                                <CrossCircleIcon
                                  size="small"
                                  borderColor="transparent"
                                />
                              </Button>
                            )}
                          </div>
                          {error ? (
                            <ErrorMessage>{error}</ErrorMessage>
                          ) : validate.current === "error" ? (
                            <ErrorMessage>
                              Please enter a valid text
                            </ErrorMessage>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </Field>
                  </div>
                </form>
              )}
            </Form>
          </div>
          {!searchText ? (
            <div className={styles.filterItem}>
              <RadioSelect
                inputId="timeframe"
                options={timeframeJobs}
                styles={CustomStyle(timeframeValue)}
                components={{ SingleValue }}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                placeholder="Start Time"
                selectLabel="Start time"
                defaultValue={{ label: "Last 7 days", value: 2 }}
                onChange={handleTimeframeChange}
                isDisabled={isLoading || searchText}
                className="radio-select"
                classNamePrefix="react-select"
              />
            </div>
          ) : (
            ""
          )}
          {!searchText ? (
            <div className={styles.filterItem}>
              <CheckboxSelect
                inputId="statusList"
                options={statusList}
                styles={CustomStyle(statusValues)}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                components={{ MultiValue }}
                defaultValue={statusValues}
                placeholder="Status"
                selectLabel="Status"
                onChange={(e) => handleStatusChange(e)}
                isDisabled={isLoading || searchText}
                className="checkbox-select"
                classNamePrefix="react-select"
                isMulti
              />
            </div>
          ) : (
            ""
          )}
          {/* {!searchText ? (
            <div className={styles.filterItem}>
              <Button
                appearance="subtle"
                type="submit"
                onClick={handleFilters}
                iconBefore={<FilterIcon size="small"></FilterIcon>}
                isDisabled={isLoading}
              >
                Apply Filters
              </Button>
            </div>
          ) : (
            ""
          )} */}
        </div>
        <div className={styles.refreshContainer}>
          {!searchText ? (
            <Button
              appearance="default"
              type="submit"
              onClick={handleFilters}
              iconBefore={<FilterIcon size="small"></FilterIcon>}
              isDisabled={isLoading}
            >
              Apply Filters
            </Button>
          ) : (
            ""
          )}
          {/* <div>
            <Button
              appearance="subtle"
              onClick={handleRefreshPage}
              iconBefore={<RefreshIcon size="medium" />}
            >
              Refresh
            </Button>
          </div> */}
          <div>
            <Button
              appearance="subtle"
              onClick={handleRefreshPage}
              iconBefore={<RefreshIcon size="medium" />}
            ></Button>
          </div>
          <div className={styles.totalCount}>
            <strong>
              Total:&nbsp;
              {isLoading ? (
                <Spinner size="xsmall" appearance="invert" />
              ) : (
                totalPages
              )}
            </strong>
          </div>
        </div>
      </div>

      <div className={styles.tablecontainer}>
        <TableWrapper>
          <DynamicTable
            head={head}
            rows={rows}
            rowsPerPage={undefined}
            defaultPage={1}
            loadingSpinnerSize="large"
            isLoading={isLoading}
            onSetPage={handleSetPage}
            emptyView={<strong>No data found</strong>}
          />
        </TableWrapper>
        {totalPages !== 0 ? (
          <div className={styles.pagination}>
            <Pagination
              pages={Array.from({
                length: Math.ceil(totalPages / pageData.pagination.size),
              }).map((currentElement, i) => i + 1)}
              onChange={onPaginationChange}
              selectedIndex={pageData.pagination.page - 1}
            />
          </div>
        ) : (
          ""
        )}
        {totalPages !== 0 ? (
          <div className={styles.downloadButton}>
            <Button
              appearance="primary"
              type="submit"
              onClick={() => setShowConfirmation(true)}
              isDisabled={downloadDisable}
              iconBefore={<DownloadIcon size="small"></DownloadIcon>}
            >
              Download CSV
            </Button>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default memo(Jobs);
